import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.FilterObjSchema>(
  'filters',
  whole => whole
);

export const denormalize = denormFn<Types.FilterObjSchema>(part => part);
